import ReactOnRails from 'react-on-rails';

import CustomerActivationTableDetail from '../bundles/ControlPanelCustomerActivations/TableDetail';

ReactOnRails.register({
  CustomerActivationTableDetail,
});
